PJQ.Binder = class {
	constructor($el, obj, options = {}) {
		this.options = _.defaults(options, {
			attribute: 'data-p-bind',
			watchElements: [
				'input',
				'textarea'
			],
			setDefaultValues: false,
			events: 'keyup change dp.change',
			delegate: false,
			onChange: null,
			afterChange: null,
			useDecimalPercentFields: false,
			canEdit: null,
			//below needed to support events for collections w/ data tables
			dataTable: null,
			idAttribute: 'cid',
			modelSelectorAttribute: 'cid',
			modelSelector: 'tr',
			validators: {}
		});

		this.$outer = $el;

		let objectType = PJQ.helpers.objectHelpers.refinedType(obj, true);
		if (objectType === 'backboneCollection') {
			this.isArray = true;
			this.obj = obj.models;
		} else if (objectType === 'array') {
			this.isArray = true;
			this.obj = obj;

		} else if (objectType === 'backboneModel' || objectType === 'object') {
			this.isBackboneObj = (objectType === 'backboneModel');
			this.obj = obj;
		}

		this.bindElements();
	}

	remove() {
		if (this.options.delegate === true) {
			this.$outer.off(this.options.events);
		} else {
			let self = this;
			_.each(this.options.watchElements, (element) => {
				this.$outer.find(element + '[' + this.options.attribute + ']').each(function () {
					$(this).off(self.options.events);
				});
			});
		}
	}

	bindElements() {
		this.requiredAttributes = [];

		this.renderInputs();

		if (this.options.delegate === true) {
			this.$outer.on(this.options.events, this.options.watchElements.join(', '), (e) => {
				this.handleChange($(e.target));
			});
		} else {
			let self = this;
			_.each(this.options.watchElements, (element) => {
				this.$outer.find(element + '[' + this.options.attribute + ']').each(function () {
					if (self.options.canEdit != null) {
						$(this).prop('disabled', !self.options.canEdit);
					}

					self.bindElement($(this));
					if (self.options.setDefaultValues && self.obj != null && !self.isArray) {
						self.setElementValue($(this))
					}
				});
			});
		}
	}

	bindElement($el) {
		let attribute = this.getElementAttribute($el);
		if (attribute != null && attribute.length > 0) {
			if ($el.prop('required') && !_.contains(this.requiredAttributes, attribute)) {
				this.requiredAttributes.push(attribute);
			}

			let self = this;
			switch (this.getElementType($el)) {
				case 'text':
					$el.on(this.options.events, function () {
						self.onChange($el, attribute, $el.val());
					});
					break;
				case 'decimal':
					$el.on(this.options.events, function () {
						let value = parseFloat($el.val());
						value = typeof value === 'number' ? value * 100 : 0;
						self.onChange($el, attribute, value);
					});
					break;
				case 'number':
					$el.on(this.options.events, function () {
						self.onChange($el, attribute, PJQ.helpers.inputHelpers.getNumberInputValue($el));
					});
					break;
				case 'percent':
					$el.on(this.options.events, function () {
						self.onChange($el, attribute, PJQ.helpers.inputHelpers.getPercentInputValue($el, self.options.useDecimalPercentFields === true));
					});
					break;
				case 'phone':
					$el.on(this.options.events, function () {
						self.onChange($el, attribute, PJQ.helpers.inputHelpers.getPhoneInputValue($el));
					});
					break;
				case 'money':
					$el.on(this.options.events, function () {
						self.onChange($el, attribute, PJQ.helpers.inputHelpers.getMoneyInputValue($el.parent()));
					});
					break;
				case 'date':
					//todo: Support date input (dates use another prototype - attempt to attach this prototype to the element somehow
					break;
				case 'select':
					$el.on(this.options.events, function () {
						let picker = $el.data('selectpickerview'),
							value = picker != null ? picker.getValue() : $el.val();
						self.onChange($el, attribute, value);
					});
					break;
				case 'bool':
					$el.on(this.options.events, function () {
						let opposite = $el.data('pBindOpposite') === true,
							val = $el.prop('checked');
						self.onChange($el, attribute, opposite ? !val : val);
					});
					break;
			}
		}
	}

	renderInputs() {
		this.inputs = {
			selectPickers: {},
			datePickers: {},
			buttonGroups: {},
			groupPickers: {},
			locationPickers: {},
			contactSelectors: {},
			fileUploaders: {},
			all: {}
		}
		this.attributeListeners = {};

		if (this.options.inputs == null) {
			return;
		}

		_.each(this.options.inputs, (inputOpts, attribute) => {
			if (typeof inputOpts.onChange === 'function' || typeof inputOpts.afterChange === 'function') {
				this.attributeListeners[attribute] = {
					onChange: inputOpts.onChange,
					afterChange: inputOpts.afterChange
				};
			}

			let $el = this.getAttributeElement(attribute);
			if ($el.length === 0) {
				return false;
			}

			let fnRender = ($input) => {
				if (inputOpts.selectPicker != null) {
					this.renderSelectPicker($input, attribute, inputOpts.selectPicker);
				} else if (inputOpts.datePicker != null) {
					this.renderDatePicker($input, attribute, inputOpts.datePicker);
				} else if (inputOpts.groupPicker != null) {
					this.renderGroupPicker($input, attribute, inputOpts.groupPicker);
				} else if (inputOpts.locationPicker != null) {
					this.renderLocationPicker($input, attribute, inputOpts.locationPicker);
				} else if (inputOpts.contactSelector != null) {
					this.renderContactSelector($input, attribute, inputOpts.contactSelector);
				} else if (inputOpts.fileUploader != null) {
					this.renderFileUploader($input, attribute, inputOpts.fileUploader);
				} else if (inputOpts.buttonGroup != null) {
					this.renderButtonGroup($input, attribute, inputOpts.buttonGroup);
				}
			}
			if ($el.length > 1) {
				$el.each(function () {
					fnRender($(this));
				});
				return;
			} else {
				fnRender($el);
			}

			if ((inputOpts.required || $el.prop('required')) && !_.contains(this.requiredAttributes, attribute)) {
				this.requiredAttributes.push(attribute);
			}
		});
	}

	getInputObj(attribute, modelId = null) {
		let attr = attribute;
		if (modelId != null) {
			attr = attribute + "_" + modelId;
		}
		return this.inputs.all[attr];
	}

	getInput(attribute, modelId = null) {
		return this.getInputObj(attribute, modelId)?.input ?? null;
	}

	renderGroupPicker($el, attribute, pickerOpts) {
		let obj = this.obj;
		if (this.isArray) {
			obj = this.getArrayObjectForElement($el);
		}

		if (obj == null)
			return;

		let value = null;
		if (typeof obj.get === 'function') {
			value = obj.get(attribute);
		} else {
			value = obj[attribute];
		}

		let optChange = pickerOpts?.onChange;
		this.inputs.all[attribute] = this.inputs.groupPickers[attribute] = {
			input: new PJQ.inputs.GroupPicker(_.defaults({
				el: $el,
				project: this.options.project,
				canEdit: pickerOpts.canEdit != null ? pickerOpts.canEdit : (this.options.canEdit ?? true),
				defaultValue: pickerOpts.defaultValue ?? value,
				onChange: (value) => {
					this.onChange($el, attribute, value);

					if (typeof optChange === 'function') {
						optChange(value);
					}
				}
			}, pickerOpts))
		};
	}

	renderLocationPicker($el, attribute, pickerOpts) {
		if (this.options.project == null && pickerOpts.project == null) {
			return;
		}

		let obj = this.obj;
		if (this.isArray) {
			obj = this.getArrayObjectForElement($el);
		}

		if (obj == null)
			return;

		let value = null;
		if (typeof obj.get === 'function') {
			value = obj.get(attribute);
		} else {
			value = obj[attribute];
		}

		let optChange = pickerOpts?.onChange;
		this.inputs.all[attribute] = this.inputs.locationPickers[attribute] = {
			input: new PJQ.inputs.ProjectLocationPicker(_.defaults({
				el: $el,
				project: this.options.project,
				canEdit: pickerOpts.canEdit != null ? pickerOpts.canEdit : (this.options.canEdit ?? true),
				defaultValue: pickerOpts.defaultValue ?? value,
				onChange: (value) => {
					this.onChange($el, attribute, value);

					if (typeof optChange === 'function') {
						optChange(value);
					}
				}
			}, pickerOpts))
		};
	}

	renderContactSelector($el, attribute, pickerOpts) {
		let obj = this.obj;
		if (this.isArray) {
			obj = this.getArrayObjectForElement($el);
		}

		if (obj == null)
			return;

		// first try to get a collection object inside the model (not the attributes)
		let value = obj[attribute],
			objectType = PJQ.helpers.objectHelpers.refinedType(value, true),
			collection = null;
		if (value == null) {
			if (typeof obj.get === 'function') {
				value = obj.get(attribute);
			} else {
				value = obj[attribute];
			}
		} else if (objectType === 'backboneCollection') {
			collection = value;
		}

		let optChange = pickerOpts?.onChange;
		this.inputs.all[attribute] = this.inputs.contactSelectors[attribute] = {
			input: new PJQ.views.contacts.ContactsSelectInput(_.defaults({
				el: $el,
				project: this.options.project,
				canEdit: pickerOpts.canEdit != null ? pickerOpts.canEdit : (this.options.canEdit ?? true),
				selectedContact: pickerOpts.selectedContact ?? collection?.models ?? value,
				onChange: (value) => {
					if (this.isBackboneObj) {
						obj.set('isDirty', true);
					}

					this.onChange($el, attribute, value);

					if (typeof optChange === 'function') {
						optChange(value);
					}
				}
			}, pickerOpts)),
			setValue: (value) => {
				if (collection != null) {
					collection.reset(value);
				} else {
					obj[attribute] = value;
				}

				if (this.isBackboneObj) {
					obj.isDirty = true;
				}
			}
		};
	}

	renderSelectPicker($el, attribute, pickerOpts) {
		let obj = this.obj;
		if (this.isArray) {
			obj = this.getArrayObjectForElement($el);
		}

		if (obj == null)
			return;

		let value = null;
		if (typeof obj.get === 'function') {
			value = obj.get(attribute);
		} else {
			value = obj[attribute];
		}

		let optChange = pickerOpts?.onChange;
		this.inputs.all[attribute] = this.inputs.selectPickers[attribute] = {
			input: new PJQ.inputs.Selectpicker(_.defaults({
				el: $el,
				canEdit: pickerOpts.canEdit != null ? pickerOpts.canEdit : (this.options.canEdit ?? true),
				defaultValue: pickerOpts.defaultValue ?? value,
				onChange: (value) => {
					this.onChange($el, attribute, value);

					if (typeof optChange === 'function') {
						optChange(...arguments);
					}
				}
			}, pickerOpts))
		};
	}

	renderDatePicker($el, attribute, pickerOpts) {
		let obj = this.obj;
		if (this.isArray) {
			obj = this.getArrayObjectForElement($el);
		}

		if (obj == null)
			return;

		let value = null;
		if (typeof obj.get === 'function') {
			value = obj.get(attribute);
		} else {
			value = obj[attribute];
		}

		let optChange = pickerOpts?.onChange;
		pickerOpts = _.defaults({
			el: $el,
			canEdit: pickerOpts.canEdit != null ? pickerOpts.canEdit : (this.options.canEdit ?? true),
			onChange: (value) => {
				this.onChange($el, attribute, value);

				if (typeof optChange === 'function') {
					optChange(value);
				}
			}
		}, pickerOpts);

		if (pickerOpts.datepickerOptions == null) {
			pickerOpts.datepickerOptions = {
				format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
			}
		}

		let defVal = pickerOpts.datepickerOptions.defaultValue ?? value;
		pickerOpts.datepickerOptions.defaultDate = typeof defVal === 'function' ? defVal(obj) : defVal;

		// todo: support datepicker collections
		this.inputs.all[attribute] = this.inputs.datePickers[attribute] = {
			input: new PJQ.inputs.Datepicker(pickerOpts)
		};
	}

	renderButtonGroup($el, attribute, opts) {
		let obj = this.obj;
		if (this.isArray) {
			obj = this.getArrayObjectForElement($el);
		}

		if (obj == null)
			return;

		let value = null;
		if (typeof obj.get === 'function') {
			value = obj.get(attribute);
		} else {
			value = obj[attribute];
		}

		let optChange = opts?.onChange;
		this.inputs.all[attribute] = this.inputs.buttonGroups[attribute] = {
			input: new PJQ.inputs.ButtonGroup(_.defaults({
				el: $el,
				defaultValue: opts.defaultValue ?? value,
				buttons: typeof opts.buttons === 'function' ? opts.buttons(obj) : opts.buttons,
				canEdit: opts.canEdit != null ? opts.canEdit : (this.options.canEdit ?? true),
				onChange: (value) => {
					this.onChange($el, attribute, value);

					if (typeof optChange === 'function') {
						optChange(value);
					}
				}
			}, opts))
		};
	}

	renderFileUploader($el, attribute, opts) {
		let obj = this.obj;
		if (this.isArray) {
			obj = this.getArrayObjectForElement($el);
		}

		if (obj == null)
			return;

		// first try to get a collection object inside the model (not the attributes)
		let value = obj[attribute],
			objectType = PJQ.helpers.objectHelpers.refinedType(value, true),
			collection = null;
		if (value == null) {
			if (typeof obj.get === 'function') {
				value = obj.get(attribute);
			} else {
				value = obj[attribute];
			}
		} else if (objectType === 'backboneCollection') {
			collection = value;
		}

		let optSuccess = opts.onSuccess,
			optDelete = opts.onDelete;
		this.inputs.all[attribute] = this.inputs.fileUploaders[attribute] = {
			input: new PJQ.views.files.FileUploaderGrid(_.defaults({
				el: $el,
				collection: collection,
				canUpload: opts.canUpload != null ? opts.canUpload : (this.options.canEdit ?? true),
				canDelete: opts.canDelete != null ? opts.canDelete : (this.options.canEdit ?? true),
				onSuccess: this.isBackboneObj ? () => {
					obj.isDirty = true;

					if (typeof optSuccess === 'function') {
						optSuccess(value);
					}
				} : null,
				onDelete: (attachment, callback) => {
					if (attachment.id > 0) {
						attachment.set('delete', true);
					} else {
						attachment.destroy();
					}

					obj.isDirty = true;

					if (typeof optDelete === 'function') {
						optDelete(value);
					}

					callback();
				}
			}, opts))
		};
	}

	getAttributeElement(attr) {
		return this.$outer.find('[' + this.options.attribute + '="' + attr + '"]');
	}

	getArrayObjectForElement($el) {
		let id = $el.closest(_.size(this.options.modelSelector) > 0 ? this.options.modelSelector : 'tr').attr(this.options.modelSelectorAttribute);
		if (_.size(id) <= 0) {
			return null;
		}
		return _.find(this.obj, function (obj) {
			return obj[this.options.idAttribute] === id;
		}, this);
	}

	setValue(attribute, value, changedObj, $el = null, updateElement = true) {
		if (_.size(attribute) === 0) {
			return;
		}

		// if there is a contact selector associated with this
		// then we need to update the contacts collection/model at the root of the object
		let input = this.getInputObj(attribute);
		if (this.isArray) {
			if (!changedObj) {
				if (_.size($el) === 0) {
					return;
				}
				changedObj = this.getArrayObjectForElement($el);
			}

			if (changedObj == null) {
				return;
			}

			if (typeof changedObj.set === 'function') {
				changedObj.set(attribute, value);
			} else {
				changedObj[attribute] = value;
			}
		} else if (input != null && typeof input.setValue === 'function') {
			input.setValue(value);
		} else if (this.isBackboneObj) {
			this.obj.set(attribute, value);
		} else {
			this.obj[attribute] = value;
		}

		if (updateElement) {
			if (_.size($el) === 0) {
				$el = this.getAttributeElement(attribute);
			}

			if (input != null) {
				// todo: update input if not null
			} else if (_.size($el) > 0) {
				this.setElementValue($el);
			}
		}
	}

	setElementValue($el) {
		let obj = this.obj;
		if (this.isArray) {
			obj = this.getArrayObjectForElement($el);
		}

		if (obj == null)
			return;

		let value = null,
			attribute = this.getElementAttribute($el);
		if (typeof obj.get === 'function') {
			value = obj.get(attribute);
		} else {
			value = obj[attribute];
		}

		let elType = this.getElementType($el);
		if (elType === 'bool') {
			let opposite = $el.data('pBindOpposite') === true;
			value = opposite ? value === false : value;
		}

		if (value != null) {
			switch (this.getElementType($el)) {
				case 'text':
				case 'number':
					$el.val(value);
					break;
				case 'percent':
					$el.val(PJQ.helpers.formatHelpers.formatPercent(this.options.useDecimalPercentFields === true ? value : value / 100));
					break;
				case 'bool':
					$el.prop('checked', value);
					break;
				case 'phone':
					$el.val(PJQ.helpers.formatHelpers.formatPhoneNumber(value));
					break;
				case 'decimal':

					break;
				case 'select':
					// this is handled in the selectpicker when it is initialized
					break;
				case 'date':
				case 'datetime':
				case 'time':
					// this is handled in the datetimepicker when it is initialized
					break;
				case 'money':
					$el.val(PJQ.helpers.formatHelpers.formatCurrency(value, 2));
					break;
			}
		}
	}

	handleChange($el) {
		let attribute = this.getElementAttribute($el),
			self = this;
		if (_.size(attribute) > 0) {
			switch (this.getElementType($el)) {
				case 'text':
					self.onChange($el, attribute, $el.val());
					break;
				case 'decimal':
					self.onChange($el, attribute, PJQ.helpers.inputHelpers.getMoneyInputValue($el) / 100);
					break;
				case 'number':
					self.onChange($el, attribute, PJQ.helpers.inputHelpers.getNumberInputValue($el));
					break;
				case 'percent':
					self.onChange($el, attribute, PJQ.helpers.inputHelpers.getPercentInputValue($el, self.options.useDecimalPercentFields === true));
					break;
				case 'phone':
					self.onChange($el, attribute, PJQ.helpers.inputHelpers.getPhoneInputValue($el));
					break;
				case 'money':
					self.onChange($el, attribute, PJQ.helpers.inputHelpers.getMoneyInputValue($el.parent()));
					break;
				case 'hours':
					break;
				case 'time':
					//todo: Support date input (dates use another prototype - attempt to attach this prototype to the element somehow
					break;
				case 'date':
				case 'datetime':
					// date/datetime is handled by the datepicker
					// this should never be hit
					break;
				case 'select':
					// select is ideally handled by defining an input so the binder initializes the selectpicker
					// if select is provided in the watchElements, then we can handle it here
					let picker = $el.data('selectpicker'),
						value = picker != null ? picker.getValue() : $el.val();
					self.onChange($el, attribute, value);
					break;
				case 'bool':
					let opposite = $el.data('pBindOpposite') === true,
						val = $el.prop('checked');
					self.onChange($el, attribute, opposite ? !val : val);
					break;
			}
		}
	}

	getElementAttribute($el) {
		return $el.attr(this.options.attribute);
	}

	getElementType($el) {
		if ($el.is('input')) {
			if ($el.hasClass('input-dollars-full') || $el.hasClass('input-dollars') || $el.hasClass('input-cents')) {
				return 'money';
			} else if ($el.hasClass('input-phone')) {
				return 'phone';
			} else if ($el.hasClass('input-percent')) {
				return 'percent';
			} else if ($el.hasClass('input-numeric')) {
				return 'number';
			} else if ($el.hasClass('input-decimal')) {
				return 'decimal';
			} else if ($el.hasClass('input-time')) {
				return 'time';
			} else if ($el.hasClass('input-hours')) {
				return 'hours';
			} else if ($el.attr('type') === 'checkbox') {
				return 'bool';
			} else if ($el.data('DateTimePicker') != null || $el.hasClass('input-date')) {
				return 'date';
			} else {
				return 'text';
			}
		} else if ($el.is('textarea')) {
			return 'text';
		} else if ($el.is('select')) {
			return 'select';
		}
	}

	onChange($el, attribute, value) {
		if (attribute.length > 0) {
			let attrListener = this.attributeListeners[attribute],
				changedObj = this.obj;
			if (this.isArray) {
				changedObj = this.getArrayObjectForElement($el);
			}

			if (typeof attrListener?.onChange === 'function') {
				attrListener.onChange($el, attribute, value, changedObj);
			} else if (typeof this.options.onChange === 'function') {
				this.options.onChange($el, attribute, value, changedObj);
			} else {
				this.setValue(attribute, value, changedObj, $el, false);
			}

			if (typeof this.options.afterChange === 'function') {
				this.options.afterChange($el, attribute, value, changedObj);
			}
			if (typeof attrListener?.afterChange === 'function') {
				attrListener.afterChange($el, value, changedObj);
			}
		}
	}

	getValidator(attribute) {
		let inputOpts = this.options.inputs != null ? this.options.inputs[attribute] : null,
			validator = null;
		if (inputOpts != null) {
			validator = inputOpts.validator;

			if (validator == null) {
				validator = {
					func: inputOpts.validate ?? null
				};
			}
		} else if (this.options.validators != null) {
			validator = this.options.validators[attribute];
		}

		return validator ?? null;
	}

	validate(options = {showInputErrors: true}) {
		let self = this,
			result = {
				isValid: true,
				validAttributes: [],
				invalidAttributes: [],
				errors: []
			};
		if (this.isArray) {
			// add if needed
		} else {
			_.each(this.requiredAttributes, (attr) => {
				let validator = this.getValidator(attr),
					value = this.isBackboneObj ? this.obj.get(attr) : self.obj[attr],
					isValid = true,
					$el = null;
				if (typeof validator?.func === 'function') {
					let validatorRes = validator.func(value, this.obj);
					if (typeof validatorRes === 'boolean') {
						isValid = validatorRes;
					} else {
						isValid = validatorRes?.isValid ?? false;
					}

					if (_.size(validatorRes?.errors) > 0) {
						result.errors.push(...validatorRes.errors);
					}
				} else {
					$el = self.getAttributeElement(attr);

					// todo: allow rules to be passed in rather than always needing a function validator
					let rules = validator?.rules ?? [],
						elType = self.getElementType($el);
					switch (elType) {
						case 'text':
						case 'phone':
							isValid = _.size(value) > 0;
							break;
						case 'select':
							let picker = $el.data('selectpickerview');
							if (picker && value != null) {
								// it is valid if we find at least 1 matching choice
								let isArr = _.isArray(value);
								isValid = null != _.find(picker.options.choices, (choice) => {
									return isArr ? _.contains(value, choice.id) : choice.id === value;
								});
							} else {
								isValid = typeof value === 'number' || _.size(value) > 0;
							}
							break;
						default:
							isValid = value != null;
							break;
					}
				}

				if (isValid) {
					result.validAttributes.push(attr);
				} else {
					result.invalidAttributes.push(attr);
				}

				if (options.showInputErrors !== false) {
					if ($el == null) {
						$el = self.getAttributeElement(attr);
					}
					PJQ.helpers.inputHelpers.setInputError($el, isValid);
				}
			});
		}

		result.isValid = _.size(result.invalidAttributes) === 0;
		return result;
	}
}